module.exports = __webpack_public_path__ + "static/media/icon-doc.52cbd35b.svg";